import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';    


function ShowProjectInformation(props) {


    // const modules = {
    //     toolbar: [
    //         [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    //         [{ 'header': [1, 2, 3, 4, 5] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'color': ['black','#80002A', '#440119', '#FFB3CA', '#0fba9c', '#C6FAF1', 
    //                              '#091EB7', '#C2C9FC', '#BFBFBF', '#7F7F7F', '#E4E4E4'] }],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'script': 'sub' }, { 'script': 'super' }],
    //         [{ 'indent': '-1' }, { 'indent': '+1' }],
    //         ['link', 'image'],
    //     ]
    // };

    const modules_none = {
        toolbar: null,
        clipboard: {
            matchVisual: false
        }
    };

    
    return(<>
        <p style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'0px', 
                     'fontSize': '24px', 'fontWeight':'bold', position: 'relative', left:'3%', width:'94%'}} >
             {props.projectInfo.title}</p>
        <h4 style = {{'margin':'0', 'marginBottom':'10px', marginTop:'25px', 'padding':'0px', position: 'relative', left:'3%', width:'94%'}} >Project Description</h4>
        <div style = {{position: 'relative', left:'3%', width:'94%'}}>
            <ReactQuill readOnly={true} modules={modules_none} theme="snow" value={props.projectInfo.description} onChange={props.handleDescription} />
        </div>





    </>);

    }

 export default ShowProjectInformation